import { combineReducers } from 'redux';
import allSurveys, {
	InitialAllSurveysResultReducer,
} from './allSurveysResult.reducer';
import dashboard, { InitialDashboardReducer } from './dashboard.reducer';
import comments, { InitialCommentsReducer } from './comments.reducer';
import persona, { InitialPersonaReducer } from './persona.reducer';
import map, { InitialMapReducer } from './map.reducer';
import summary, { InitialSummaryReducer } from './summary.reducer';

export const InitialSurveyResultsReducer = {
	allSurveys: InitialAllSurveysResultReducer,
	comments: InitialCommentsReducer,
	dashboard: InitialDashboardReducer,
	summary: InitialSummaryReducer,
	persona: InitialPersonaReducer,
	map: InitialMapReducer,
};

export default combineReducers({
	allSurveys,
	comments,
	dashboard,
	summary,
	persona,
	map,
});
